import { trim, truncate, isEmpty } from 'lodash';
import moment from 'moment-timezone';

//trim notes
export function trimAndLimit(text, limit = 250) {

    if(!isEmpty(text)){
        // Remove HTML tags using DOMParser
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const plainText = doc.body.textContent || '';
        
        // Trim whitespace and limit to 250 characters
        const trimmedText = truncate(trim(plainText), { length: limit });
    
        return !isEmpty(trimmedText)? trimmedText : '';
    }
    return text;
    
}

export function getFormatedDateTime(dateStr, format = 'MM/DD/YY H:mm:ss'){
    return moment(dateStr).format(format);
}

export const formatTime = (seconds) => { 
    if (isNaN(seconds) || seconds < 0) {
        return '00:00:00';
    }
    const duration = moment.duration(seconds, 'seconds');
    const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
    const minutes = duration.minutes().toString().padStart(2, '0');
    const secs = duration.seconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${secs}`;
};

export const getWeekEndingDates = () => {
  const weeks = [];
  const today = moment();

  const generateWeeksForMonth = (dateForMonth) => {
    const monthWeeks = [];
    const startOfMonth = dateForMonth.clone().startOf("month");
    const endOfMonth = dateForMonth.clone().endOf("month");

    let current = startOfMonth.clone().startOf("isoWeek");

    const hardStop = endOfMonth.clone().add(14, "days");

    while (current.isSameOrBefore(hardStop)) {
      const weekStartDate = current.clone();
      const weekEndDate = current.clone().endOf("isoWeek");

      // ✅ FIX: include weeks overlapping the month
      if (
        weekEndDate.isSameOrAfter(startOfMonth) &&
        weekStartDate.isSameOrBefore(endOfMonth)
      ) {
        monthWeeks.push(weekEndDate.format("YYYY-MM-DD"));
      }

      current.add(1, "week");
    }

    return monthWeeks;
  };

  const prevMonth = today.clone().subtract(1, "month");

  weeks.push(...generateWeeksForMonth(prevMonth));
  weeks.push(...generateWeeksForMonth(today));

  return [...new Set(weeks)].sort((a, b) =>
    moment(a, "YYYY-MM-DD").diff(moment(b, "YYYY-MM-DD"))
  );
};
